{
  "version": 1,
  "asset_id": "94d6dbeb-2e54-4238-8fb1-c58b8618ef37",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/94d6dbeb-2e54-4238-8fb1-c58b8618ef37/aicpa.webp",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/94d6dbeb-2e54-4238-8fb1-c58b8618ef37/aicpa.webp",
  "original_filename": "aicpa.webp",
  "size": 4658,
  "content_type": "image/webp",
  "created_at": "2026-06-26T16:15:08Z"
}
